const translations = {
  en: {
    "nav.home": "Home",
    "nav.features": "Features",
    "nav.products": "Products",
    "nav.contact": "Contact",
    "nav.documentation": "Documentation",

    "hero.title": "Bring Trusted Data into Your AI Applications",
    "hero.subtitle":
      "Connect AI products to GuGuData's specialized data through one supported access path. Review connector fit, test the documented workflow, and request the API access your team needs.",
    "hero.cta": "Request API Access",
    "hero.secondaryCta": "Read Documentation",
    "hero.tertiaryCta": "Contact the Team",
    "hero.valuePoint1": "Education, finance, weather, document, and web data",
    "hero.valuePoint2": "Documented requests and playground evaluation",
    "hero.valuePoint3": "Data services since 2015 with API key onboarding support",

    "trust.title": "A Clear Path from Evaluation to Production",
    "trust.subtitle": "Make an informed integration decision with concrete data coverage, documented workflows, and direct onboarding support.",
    "trust.point1.title": "Data services since 2015",
    "trust.point1.description": "GuGuData brings established data-service experience to teams building AI products and data-assisted workflows.",
    "trust.point2.title": "Evaluate before integration",
    "trust.point2.description": "Review connector categories, request examples, and playground behavior before deciding on production access.",
    "trust.point3.title": "Scope access around your use case",
    "trust.point3.description": "Confirm the data categories, expected volume, launch timeline, and support needs with our team.",

    "features.title": "The Power of MCP Protocol",
    "features.subtitle": "Discover how MCP can transform your AI applications by standardizing data access across all sources.",
    "features.card1.title": "Seamless Integration",
    "features.card1.description": "Connect any data source to your LLM with minimal code changes, using our standardized protocol.",
    "features.card2.title": "Modular Architecture",
    "features.card2.description": "Add and remove data sources on demand, enabling your AI to access exactly what it needs.",
    "features.card3.title": "Enhanced Context",
    "features.card3.description": "Give your AI models the specialized data they need to deliver more relevant, accurate responses.",
    "features.integration.title": "How MCP Integration Works",
    "features.integration.subtitle": "Get started with MCP in three simple steps",
    "features.integration.step1.title": "Connect Your Data",
    "features.integration.step1.description": "Easily connect your existing data sources through our standardized MCP protocol interface.",
    "features.integration.step2.title": "Configure Integration",
    "features.integration.step2.description": "Set up data mapping and transformation rules with our intuitive configuration tools.",
    "features.integration.step3.title": "Enhance Your AI",
    "features.integration.step3.description": "Your AI applications now have seamless access to all connected data sources.",
    "features.standardized.title": "Standardized Protocol",
    "features.standardized.description": "MCP provides a standardized way for AI models to interact with various data sources and tools, creating a common framework that simplifies integration.",
    "features.standardized.list.item1": "Consistent data formatting across platforms",
    "features.standardized.list.item2": "Reduced development complexity",
    "features.standardized.list.item3": "Universal compatibility between models and data sources",
    "features.modular.title": "Modular Integration",
    "features.modular.description": "The MCP architecture allows developers to easily plug in different data sources as modular components, enhancing your AI's capabilities on demand.",
    "features.modular.list.item1": "Plug-and-play data source integration",
    "features.modular.list.item2": "Easy switching between different LLM providers",
    "features.modular.list.item3": "Scalable architecture that grows with your needs",
    "features.cta.title": "Ready to supercharge your AI?",
    "features.cta.description": "Join the growing ecosystem of companies using MCP protocol to connect their data to AI systems.",
    "features.cta.button": "Contact Us",
    "features.external_resources.title": "Related Resources",
    "features.external_resources.subtitle": "Explore external resources and documentation to enhance your MCP integration",
    "features.external_resources.mcp_spec": "MCP Specification",
    "features.external_resources.mcp_spec_desc": "Official MCP protocol specification and implementation guidelines",
    "features.external_resources.github_samples": "GitHub Examples",
    "features.external_resources.github_samples_desc": "Sample implementations and code examples for MCP integration",
    "features.external_resources.community": "Developer Community",
    "features.external_resources.community_desc": "Community-maintained MCP servers and integration examples",

    "products.title": "Our Products",
    "products.subtitle": "Explore our MCP implementation solutions for enhancing your AI capabilities.",
    "products.card1.title": "MCP Core API",
    "products.card1.description": "Our flagship API service that enables seamless integration between LLMs and data sources. Connect once to our API and gain access to all compatible data providers.",
    "products.card1.cta": "View Documentation",
    "products.card2.title": "MCP Data Connectors",
    "products.card2.description": "Pre-built connectors for popular data sources and specialized knowledge bases. Simply enable the ones you need to enhance your AI capabilities.",
    "products.card2.cta": "Explore Connectors",
    "products.page.hero.title": "Data Connectors for Production AI Workflows",
    "products.page.hero.subtitle":
      "Evaluate specialized data for your AI product, verify the documented request flow, and request API access scoped to your connector and rollout needs.",
    "products.page.hero.primaryCta": "Request API Access",
    "products.page.hero.secondaryCta": "Read Documentation",
    "products.page.hero.proof1": "Specialized data across education, finance, weather, documents, and web utilities",
    "products.page.hero.proof2": "Documented request examples and playground evaluation",
    "products.page.hero.proof3": "API key onboarding matched to connector scope and launch needs",
    "products.page.core.title": "MCP Core API",
    "products.page.core.description": "A unified API layer for connecting AI applications to GuGuData data capabilities and enabled connector groups.",
    "products.page.core.point1": "Authenticated JSON requests for AI application workflows",
    "products.page.core.point2": "Playground stream endpoint for evaluating data-assisted answers",
    "products.page.core.point3": "Documentation and examples for developer onboarding",
    "products.page.core.cta": "View API Documentation",
    "products.page.connectors.title": "MCP Data Connectors",
    "products.page.connectors.description": "Connector groups expose specialized data categories that can be enabled for the use cases your application needs.",
    "products.page.connectors.point1": "Education, finance, lunar calendar, weather, and web utility examples",
    "products.page.connectors.point2": "Designed for MCP and AI data integration workflows",
    "products.page.connectors.point3": "Clear path for teams to request additional connector coverage",
    "products.page.connectors.cta": "Explore Connector Examples",
    "products.page.support.title": "Integration Support",
    "products.page.support.description": "For production access, our team helps confirm the right connector scope, API key access, and integration approach.",
    "products.page.support.point1": "API key request and onboarding guidance",
    "products.page.support.point2": "Connector enablement for specific application scenarios",
    "products.page.support.point3": "Business and partnership conversations through the contact path",
    "products.page.support.cta": "Request API Access",
    "products.page.connectorExamples.title": "Connector Example Themes",
    "products.page.connectorExamples.description": "These themes show common ways teams can bring specialized data into AI applications through MCP connectors, API access, and integration support.",
    "products.page.theme.education.title": "Education Data",
    "products.page.theme.education.description": "University, ranking, and learning-resource data for research, content, and education workflows.",
    "products.page.theme.finance.title": "Finance Data",
    "products.page.theme.finance.description": "Market information and financial reference data for AI-assisted analysis and retrieval.",
    "products.page.theme.webtools.title": "Document & Web Tools",
    "products.page.theme.webtools.description": "PDF, content extraction, SSL, and web utility capabilities for practical AI applications.",
    "products.page.theme.custom.title": "Custom Connector Requests",
    "products.page.theme.custom.description": "Teams can contact GuGuData to discuss connector coverage for their own application scenario.",
    "products.page.journey.title": "Access Path for Teams",
    "products.page.journey.description": "The site is designed to help teams understand the product, review the documentation, and contact GuGuData for API access.",
    "products.page.journey.step1.title": "Explore the product fit",
    "products.page.journey.step1.description": "Review how the MCP API and connector categories can support your AI application's data needs.",
    "products.page.journey.step2.title": "Review the API workflow",
    "products.page.journey.step2.description": "Use the documentation and playground examples to understand the authenticated stream request pattern.",
    "products.page.journey.step3.title": "Request access and connector scope",
    "products.page.journey.step3.description": "Contact the team to request an API key and confirm which connector groups should be enabled.",
    "products.page.journey.cta": "Request Access",
    "products.page.finalCta.title": "Bring specialized data into your AI workflow",
    "products.page.finalCta.description": "Use the product page to evaluate the MCP data access model, then contact GuGuData for API access and connector enablement.",
    "products.page.finalCta.primary": "Contact the Team",
    "products.page.finalCta.secondary": "Read the Docs",

    "footer.copyright": "All rights reserved.",
    "footer.address": "Address",
    "footer.contact": "Contact",
    "footer.legal": "Terms of Service",
    "footer.privacy": "Privacy Policy",
    "footer.products": "Products",
    "footer.chinese_service": "Chinese Data Service",
    "footer.global_service": "Global Data Service",
    "footer.resources": "Resources",
    "footer.mcp_docs": "MCP Protocol",
    "footer.anthropic": "Anthropic Claude",
    "footer.openai": "OpenAI Platform",
    "footer.description": "Standardizing AI data integration with MCP protocol",

    // Adding chat-related translations
    "chat.tryExamples": "Try these examples:",
    "chat.example1": "What is the next solar term in the 24 solar terms?",
    "chat.example2": "List the names of top 10 Project 211 universities in Jiangsu Province.",
    "chat.example3": "Show me the real-time basic information of A-share stock 600000.",
    "chat.example4": "Tell me the top 5 universities in the latest QS World University Rankings.",
    "chat.placeholder": "Ask about MCP data integration...",
    "chat.title": "Ask GuGuData AI with MCP",
    "chat.description": "Experience the power of MCP connectors. Toggle plugins above to enhance AI capabilities with specialized data sources.",

    "contact.title": "Contact Us",
    "contact.subtitle": "Choose the fastest path for API access or a general data inquiry.",
    "contact.apiAccess.title": "Request GuGuData.AI API Access",
    "contact.apiAccess.description": "Tell us what your AI application needs so we can confirm connector fit, access scope, and the right evaluation path.",
    "contact.apiAccess.cta": "Start an API Key Request",
    "contact.apiAccess.guidance": "Include your use case, required data categories, expected request volume, and target launch timeline.",
    "contact.general.title": "General Data Inquiry",
    "contact.general.description": "Contact our team about data coverage, partnerships, support, or another GuGuData service.",
    "contact.general.cta": "Email the Team",
    "contact.sections.coreAdvantages": "Core Advantages",
    "contact.sections.technicalFeatures": "Technical Features",
    "contact.sections.solutions": "Solutions",
    "contact.intro.paragraph1":
      "Founded in 2015, GuGuData has evolved from a data management solution into a comprehensive data hub. Our mission is to empower businesses with seamless access to specialized data through our innovative MCP protocol.",
    "contact.intro.paragraph2":
      "Seamless integration capabilities with minimal code changes. Connect any data source to your LLM through our standardized protocol, optimizing enterprise data storage and performance.",
    "contact.intro.paragraph3":
      "Modular architecture with on-demand data source management. Our categorized interfaces provide versatile solutions across various domains for businesses and researchers.",
    "contact.intro.paragraph4": "Comprehensive toolkit for data processing, including PDF generation, content extraction, and SSL parsing. An ideal solution for both startups and enterprises.",
    "contact.intro.paragraph5": "We've recently launched internationalized sites and APIs, expanding our reach and making our data solutions accessible to a global audience.",
    "contact.intro.paragraph6": "For any data needs, inquiries, feedback, or partnership opportunities, feel free to reach out to us.",
    "contact.info.title": "Contact Information",
    "contact.info.email": "Email",
    "contact.info.address": "1111B S Governors Ave STE 3590\nDover, DE 19904, United States",
    "contact.info.company": "GuGuData, LLC",

    "plugins.financial.title": "Financial Data",
    "plugins.financial.description": "Access real-time financial market data and analysis tools",
    "plugins.education.title": "Educational Resources",
    "plugins.education.description": "Connect to educational databases and learning materials",
    "plugins.lunar.title": "Lunar Data",
    "plugins.lunar.description": "Get information about lunar calendar and festivals",
    "plugins.weather.title": "Weather",
    "plugins.weather.description": "Access real-time weather data and forecasts",
    "plugins.title": "MCP Plugins",
    "plugins.coming_soon.description": "Some connectors are available in the playground. Contact our team to enable additional data connectors for your use case.",

    // Plugin Categories
    "plugins.text.title": "NLP",
    "plugins.text.description": "Natural language processing and text analysis tools",
    "plugins.image.title": "PDF Tools",
    "plugins.image.description": "Image processing and PDF handling tools",
    "plugins.news.title": "News",
    "plugins.news.description": "News and information aggregation services",
    "plugins.finance.title": "Finance",
    "plugins.finance.description": "Basic financial data and analysis tools",
    "plugins.business.title": "Business",
    "plugins.business.description": "Business intelligence and analytics tools",
    "plugins.location.title": "Location",
    "plugins.location.description": "Geographic and coordinate-based services",
    "plugins.webtools.title": "Web Tools",
    "plugins.webtools.description": "Various web-based utilities and tools",
    "plugins.ai.title": "AI Models",
    "plugins.ai.description": "AI models and machine learning services",
    "plugins.barcode.title": "Barcode",
    "plugins.barcode.description": "Barcode generation and scanning utilities",
    "plugins.sms.title": "SMS",
    "plugins.sms.description": "SMS and voice communication services",

    "meta.contact.title": "Contact Us - GuGuData",
    "meta.contact.description": "GuGuData offers professional data services and MCP protocol integration. Contact us to learn more about our data services, API integration, and customized solutions.",
    "meta.contact.keywords": "GuGuData, MCP, data services, API integration, contact",
    "meta.home.title": "AI Data Connectors and MCP API Access | GuGuData.AI",
    "meta.home.description": "Connect AI applications to GuGuData education, finance, weather, document, and web data. Review connector fit, documentation, and API access options.",
    "meta.home.keywords": "GuGuData.AI, MCP, AI data integration, data connectors, API platform, AI applications",
    "meta.products.title": "Data Connectors for AI Workflows | GuGuData.AI",
    "meta.products.description": "Evaluate GuGuData.AI data connectors, documented request workflows, connector coverage, and API key onboarding for production AI applications.",
    "meta.products.keywords": "MCP data products, AI data connectors, MCP API, API key access, AI data integration, GuGuData.AI",
    "meta.documentation.title": "Documentation - GuGuData.AI | MCP Protocol for AI Data Integration",
    "meta.documentation.description": "Comprehensive documentation for GuGuData's MCP protocol. Learn how to integrate specialized data sources with your AI applications.",
    "meta.documentation.keywords": "GuGuData, MCP documentation, API reference, data integration, getting started, implementation guide",
    "notfound.title": "404 - Page Not Found",
    "notfound.description": "Oops! The page you're looking for doesn't exist.",
    "notfound.backHome": "Return to Home",

    "documentation.title": "Documentation",
    "documentation.introduction": "Introduction",
    "documentation.getting-started": "Getting Started",
    "documentation.features": "Features",
    "documentation.api": "API Reference",
    "documentation.examples": "Examples",
    "documentation.troubleshooting": "Troubleshooting",

    "documentation.introduction.welcome":
      "Welcome to the GuGuData MCP Protocol documentation. Here you'll find comprehensive guides and documentation to help you start working with GuGuData MCP as quickly as possible, as well as support if you get stuck.",
    "documentation.introduction.how_it_works.title": "How it Works",
    "documentation.introduction.how_it_works.description":
      "GuGuData provides a unified protocol for connecting large language models to specialized data sources. When you send a query to our API, the enabled data connectors help the model use the right domain data for the request.",
    "documentation.introduction.mcp_plugins.title": "MCP Plugins",
    "documentation.introduction.mcp_plugins.description":
      "MCP connectors enhance AI capabilities with specialized knowledge and data processing abilities. Contact our team to enable the connectors that match your application needs.",
    "documentation.introduction.mcp_plugins.chinese": "Chinese Website",
    "documentation.introduction.mcp_plugins.international": "English & Japanese Website",
    "documentation.introduction.note": "Keep your API key secure and do not share it with others. Contact our team if you need additional data connectors enabled.",

    "documentation.api.baseurl.title": "Base URL",
    "documentation.api.example.title": "Example Request",

    "documentation.getting-started.content": "To get started, contact our team for an API key and the data connectors that match your application needs.",
    "documentation.features.content": "Explore the various features of GuGuData MCP Protocol including automatic plugin loading, multilingual support, and specialized data sources.",
    "documentation.api.content":
      "Our API follows standard practices for authenticated JSON requests. The public playground stream endpoint is 'https://api.gugudata.ai/api/v1/stream' and requires your GuGuData AI API key.",
    "documentation.examples.content": "Check out these examples to learn how to integrate with different data sources using the MCP protocol.",
    "documentation.troubleshooting.content": "Find solutions to common issues and learn how to troubleshoot problems with your MCP implementation.",

    "documentation.api.authentication.title": "Authentication",
    "documentation.api.authentication.description":
      "All API requests require authentication using your GuGuData AI API key. You will need to include your API key in the Authorization header of all requests.",
    "documentation.api.authentication.header": "Authorization Header",
    "documentation.api.authentication.note": "Replace <GuGuData AI API Key> with your actual API key. Keep your API key secure and do not expose it in client-side code.",

    "documentation.api.endpoints.title": "Endpoints",
    "documentation.api.endpoints.parameter": "Parameter",
    "documentation.api.endpoints.type": "Type",
    "documentation.api.endpoints.required": "Required",
    "documentation.api.endpoints.description": "Description",
    "documentation.api.endpoints.yes": "Yes",
    "documentation.api.endpoints.no": "No",
    "documentation.api.endpoints.example_request": "Example Request",
    "documentation.api.endpoints.example_response": "Example Response",

    "documentation.api.endpoints.chat_completions.title": "Create Playground Stream Request",
    "documentation.api.endpoints.chat_completions.description": "Sends a prompt to GuGuData AI and streams back the answer from enabled data connectors.",
    "documentation.api.endpoints.chat_completions.params.title": "Request Parameters",
    "documentation.api.endpoints.chat_completions.params.model": "The user question or task to answer.",
    "documentation.api.endpoints.chat_completions.params.messages": "Optional values that provide request context.",
    "documentation.api.endpoints.chat_completions.params.stream": "Optional connector names to enable for the request.",

  },

  zh: {
    "nav.home": "首页",
    "nav.features": "功能",
    "nav.products": "产品",
    "nav.contact": "联系我们",
    "nav.documentation": "文档",

    "hero.title": "将可信专业数据接入您的 AI 应用",
    "hero.subtitle": "通过统一的接入路径连接 GuGuData 专业数据。先确认连接器与业务场景是否匹配，再验证文档流程，并申请团队所需的 API 访问。",
    "hero.cta": "申请 API 访问",
    "hero.secondaryCta": "查看文档",
    "hero.tertiaryCta": "联系团队",
    "hero.valuePoint1": "覆盖教育、金融、天气、文档和网页数据",
    "hero.valuePoint2": "提供请求文档和 Playground 评估流程",
    "hero.valuePoint3": "自 2015 年持续提供数据服务与 API Key 接入支持",

    "trust.title": "从评估到生产接入的清晰路径",
    "trust.subtitle": "通过明确的数据范围、可验证的文档流程和直接的接入支持，帮助团队做出可靠的集成决策。",
    "trust.point1.title": "自 2015 年持续提供数据服务",
    "trust.point1.description": "GuGuData 将长期积累的数据服务经验用于支持 AI 产品和数据增强业务流程。",
    "trust.point2.title": "先验证，再决定集成",
    "trust.point2.description": "在申请生产访问前，先了解连接器类别、请求示例和 Playground 的实际流程。",
    "trust.point3.title": "围绕业务场景确认访问范围",
    "trust.point3.description": "与团队确认所需数据类别、预计调用量、上线时间和支持需求。",

    "features.title": "MCP 协议的强大功能",
    "features.subtitle": "了解 MCP 如何通过标准化所有数据源的访问方式，改变您的 AI 应用程序。",
    "features.card1.title": "无缝集成",
    "features.card1.description": "使用我们的标准协议，只需少量代码更改即可将任何数据源连接到您的 LLM。",
    "features.card2.title": "模块化架构",
    "features.card2.description": "按需添加和移除数据源，使您的 AI 能够精确访问所需内容。",
    "features.card3.title": "增强上下文",
    "features.card3.description": "为您的 AI 模型提供所需的专业数据，以提供更相关、更准确的响应。",
    "features.integration.title": "MCP 集成流程",
    "features.integration.subtitle": "通过三个简单步骤开始使用 MCP",
    "features.integration.step1.title": "连接数据",
    "features.integration.step1.description": "通过我们的标准化 MCP 协议接口轻松连接您现有的数据源。",
    "features.integration.step2.title": "配置集成",
    "features.integration.step2.description": "使用我们直观的配置工具设置数据映射和转换规则。",
    "features.integration.step3.title": "增强 AI",
    "features.integration.step3.description": "您的 AI 应用程序现在可以无缝访问所有连接的数据源。",
    "features.standardized.title": "标准化协议",
    "features.standardized.description": "MCP 为 AI 模型提供了一种标准化的方式来与各种数据源和工具交互，创建了一个简化集成的通用框架。",
    "features.standardized.list.item1": "跨平台的一致数据格式",
    "features.standardized.list.item2": "降低开发复杂度",
    "features.standardized.list.item3": "模型和数据源之间的通用兼容性",
    "features.modular.title": "模块化集成",
    "features.modular.description": "MCP 架构允许开发人员轻松插入不同的数据源作为模块化组件，按需增强您的 AI 能力。",
    "features.modular.list.item1": "即插即用的数据源集成",
    "features.modular.list.item2": "轻松切换不同的 LLM 提供商",
    "features.modular.list.item3": "可随需求增长的可扩展架构",
    "features.cta.title": "准备好提升您的 AI 能力了吗？",
    "features.cta.description": "加入使用 MCP 协议连接数据的企业生态系统。",
    "features.cta.button": "联系我们",
    "features.external_resources.title": "相关资源",
    "features.external_resources.subtitle": "探索外部资源和文档以增强您的 MCP 集成",
    "features.external_resources.mcp_spec": "MCP 规范",
    "features.external_resources.mcp_spec_desc": "官方 MCP 协议规范和实施指南",
    "features.external_resources.github_samples": "GitHub 示例",
    "features.external_resources.github_samples_desc": "MCP 集成的示例实现和代码示例",
    "features.external_resources.community": "开发者社区",
    "features.external_resources.community_desc": "社区维护的 MCP 服务器和集成示例",

    "products.title": "我们的产品",
    "products.subtitle": "探索我们的 MCP 实施解决方案，增强您的 AI 能力。",
    "products.card1.title": "MCP 核心 API",
    "products.card1.description": "我们的旗舰 API 服务，实现 LLM 与数据源之间的无缝集成。只需连接一次我们的 API，即可访问所有兼容的数据提供商。",
    "products.card1.cta": "查看文档",
    "products.card2.title": "MCP 数据连接器",
    "products.card2.description": "为流行数据源和专业知识库预构建的连接器。只需启用您需要的连接器，即可增强 AI 功能。",
    "products.card2.cta": "探索连接器",
    "products.page.hero.title": "面向生产 AI 工作流的数据连接器",
    "products.page.hero.subtitle": "评估 AI 产品所需的专业数据，验证文档中的请求流程，并按照连接器范围和上线需求申请 API 访问。",
    "products.page.hero.primaryCta": "申请 API 访问",
    "products.page.hero.secondaryCta": "查看文档",
    "products.page.hero.proof1": "覆盖教育、金融、天气、文档和网页工具等专业数据",
    "products.page.hero.proof2": "提供请求示例和 Playground 评估流程",
    "products.page.hero.proof3": "根据连接器范围和上线需求提供 API Key 接入支持",
    "products.page.core.title": "MCP 核心 API",
    "products.page.core.description": "统一的 API 层，用于把 AI 应用连接到 GuGuData 的数据能力和已启用的连接器组。",
    "products.page.core.point1": "面向 AI 应用流程的认证 JSON 请求",
    "products.page.core.point2": "用于评估数据增强回答的 Playground 流式接口",
    "products.page.core.point3": "支持开发者快速了解接入方式的文档和示例",
    "products.page.core.cta": "查看 API 文档",
    "products.page.connectors.title": "MCP 数据连接器",
    "products.page.connectors.description": "连接器组提供不同专业数据类别，可按应用场景启用所需能力。",
    "products.page.connectors.point1": "教育、金融、农历、天气和网页工具等示例",
    "products.page.connectors.point2": "面向 MCP 和 AI 数据集成工作流组织能力",
    "products.page.connectors.point3": "为团队申请更多连接器覆盖提供明确路径",
    "products.page.connectors.cta": "查看连接器示例",
    "products.page.support.title": "集成支持",
    "products.page.support.description": "如需生产访问，我们会协助确认连接器范围、API Key 访问和集成方式。",
    "products.page.support.point1": "API Key 申请和接入指导",
    "products.page.support.point2": "面向具体应用场景的连接器启用",
    "products.page.support.point3": "通过联系路径推进业务和合作咨询",
    "products.page.support.cta": "申请 API 访问",
    "products.page.connectorExamples.title": "连接器示例主题",
    "products.page.connectorExamples.description": "这些主题展示团队如何通过 MCP 连接器、API 访问和集成支持，把专业数据接入 AI 应用。",
    "products.page.theme.education.title": "教育数据",
    "products.page.theme.education.description": "面向研究、内容和教育场景的高校、排名和学习资源数据。",
    "products.page.theme.finance.title": "金融数据",
    "products.page.theme.finance.description": "用于 AI 辅助分析和检索的市场信息与金融参考数据。",
    "products.page.theme.webtools.title": "文档与网页工具",
    "products.page.theme.webtools.description": "PDF、内容提取、SSL 和网页实用工具能力，服务实际 AI 应用。",
    "products.page.theme.custom.title": "定制连接器咨询",
    "products.page.theme.custom.description": "团队可以联系 GuGuData，讨论适合自身应用场景的连接器覆盖。",
    "products.page.journey.title": "团队接入路径",
    "products.page.journey.description": "本站用于帮助团队了解产品、查看文档，并联系 GuGuData 申请 API 访问。",
    "products.page.journey.step1.title": "了解产品适配度",
    "products.page.journey.step1.description": "查看 MCP API 和连接器类别如何支持 AI 应用的数据需求。",
    "products.page.journey.step2.title": "查看 API 工作流",
    "products.page.journey.step2.description": "通过文档和 Playground 示例了解认证流式请求方式。",
    "products.page.journey.step3.title": "申请访问和连接器范围",
    "products.page.journey.step3.description": "联系团队申请 API Key，并确认需要启用的连接器组。",
    "products.page.journey.cta": "申请访问",
    "products.page.finalCta.title": "把专业数据接入你的 AI 工作流",
    "products.page.finalCta.description": "通过产品页了解 MCP 数据访问模式，再联系 GuGuData 获取 API 访问和连接器启用支持。",
    "products.page.finalCta.primary": "联系团队",
    "products.page.finalCta.secondary": "查看文档",

    "footer.copyright": "保留所有权利。",
    "footer.address": "地址",
    "footer.contact": "联系方式",
    "footer.legal": "服务条款",
    "footer.privacy": "隐私政策",
    "footer.products": "产品服务",
    "footer.chinese_service": "中文数据服务",
    "footer.global_service": "全球数据服务",
    "footer.resources": "相关资源",
    "footer.mcp_docs": "MCP 协议",
    "footer.anthropic": "Anthropic Claude",
    "footer.openai": "OpenAI 平台",
    "footer.description": "使用 MCP 协议标准化 AI 数据集成",

    "chat.tryExamples": "尝试这些示例：",
    "chat.example1": "你能告诉我下一个二十四节气是什么吗？",
    "chat.example2": "给我江苏省前十个 211 大学，给我大学的名字就可以了。",
    "chat.example3": "你能告诉我 A 股股票 600000 目前实时的基本信息吗？",
    "chat.example4": "告诉我实时的全球 QS 世界大学排名前 5 的大学。",
    "chat.placeholder": "询问有关 MCP 数据集成的问题...",
    "chat.title": "使用 MCP 询问 GuGuData AI",
    "chat.description": "体验 MCP 连接器的强大功能。切换上方的插件以通过专业数据源增强 AI 能力。",

    "contact.title": "联系我们",
    "contact.subtitle": "选择 API 访问申请或一般数据咨询，快速联系对应团队。",
    "contact.apiAccess.title": "申请 GuGuData.AI API 访问",
    "contact.apiAccess.description": "告诉我们您的 AI 应用需求，我们会协助确认连接器匹配度、访问范围和评估方式。",
    "contact.apiAccess.cta": "发起 API Key 申请",
    "contact.apiAccess.guidance": "建议说明业务场景、所需数据类别、预计调用量和计划上线时间。",
    "contact.general.title": "一般数据咨询",
    "contact.general.description": "如需咨询数据覆盖、合作、支持或 GuGuData 其他服务，请联系团队。",
    "contact.general.cta": "发送咨询邮件",
    "contact.sections.coreAdvantages": "核心优势",
    "contact.sections.technicalFeatures": "技术特点",
    "contact.sections.solutions": "解决方案",
    "contact.intro.paragraph1": "GuGuData 成立于 2015 年，已从数据管理解决方案发展成为全面的数据中心。我们的使命是通过创新的 MCP 协议为企业提供无缝访问专业数据的能力。",
    "contact.intro.paragraph2": "通过我们的标准化协议，只需少量代码更改即可实现无缝集成能力。连接任何数据源到您的 LLM，优化企业数据存储和性能。",
    "contact.intro.paragraph3": "具有按需数据源管理的模块化架构。我们的分类接口为企业和研究人员提供跨领域的多样化解决方案。",
    "contact.intro.paragraph4": "全面的数据处理工具包，包括 PDF 生成、内容提取和 SSL 解析。适合初创企业和大型企业的理想解决方案。",
    "contact.intro.paragraph5": "我们最近推出了国际化站点和 API，扩大了我们的覆盖范围，使我们的数据解决方案可供全球用户使用。",
    "contact.intro.paragraph6": "如有任何数据需求、咨询、反馈或合作机会，请随时与我们联系。",
    "contact.info.title": "联系信息",
    "contact.info.email": "邮箱",
    "contact.info.address": "1111B S Governors Ave STE 3590\nDover, DE 19904, United States",
    "contact.info.company": "GuGuData, LLC",

    "plugins.financial.title": "金融数据",
    "plugins.financial.description": "访问实时金融市场数据和分析工具",
    "plugins.education.title": "教育资源",
    "plugins.education.description": "连接教育数据库和学习材料",
    "plugins.lunar.title": "农历数据",
    "plugins.lunar.description": "获取农历和节日信息",
    "plugins.weather.title": "天气",
    "plugins.weather.description": "访问实时天气数据和预报",
    "plugins.title": "MCP 插件",
    "plugins.coming_soon.description": "Playground 当前开放部分连接器。如需启用更多数据连接器，请联系我们的团队。",

    "plugins.text.title": "NLP",
    "plugins.text.description": "自然语言处理和文本分析工具",
    "plugins.image.title": "PDF 工具",
    "plugins.image.description": "图像处理和 PDF 处理工具",
    "plugins.news.title": "新闻",
    "plugins.news.description": "新闻和信息聚合服务",
    "plugins.finance.title": "金融",
    "plugins.finance.description": "基础金融数据和分析工具",
    "plugins.business.title": "商业",
    "plugins.business.description": "商业智能和分析工具",
    "plugins.location.title": "位置",
    "plugins.location.description": "地理和基于坐标的服务",
    "plugins.webtools.title": "网页工具",
    "plugins.webtools.description": "各种网络实用工具",
    "plugins.ai.title": "AI 模型",
    "plugins.ai.description": "人工智能模型和机器学习服务",
    "plugins.barcode.title": "条码",
    "plugins.barcode.description": "条码生成和扫描工具",
    "plugins.sms.title": "短信",
    "plugins.sms.description": "短信和语音通信服务",

    "meta.contact.title": "联系我们 - GuGuData",
    "meta.contact.description": "GuGuData 提供专业的数据服务和 MCP 协议集成。联系我们了解更多关于数据服务、API 集成和定制化解决方案的信息。",
    "meta.contact.keywords": "GuGuData, MCP, 数据服务, API 集成, 联系我们",
    "meta.home.title": "AI 数据连接器与 MCP API 访问 | GuGuData.AI",
    "meta.home.description": "将 AI 应用连接到 GuGuData 的教育、金融、天气、文档和网页数据，了解连接器匹配度、接入文档和 API 访问方式。",
    "meta.home.keywords": "GuGuData.AI, MCP, AI 数据集成, 数据连接器, API 平台, AI 应用",
    "meta.products.title": "面向 AI 工作流的数据连接器 | GuGuData.AI",
    "meta.products.description": "评估 GuGuData.AI 数据连接器、请求流程、数据覆盖范围，以及生产 AI 应用的 API Key 接入方式。",
    "meta.products.keywords": "MCP 数据产品, AI 数据连接器, MCP API, API Key 申请, AI 数据集成, GuGuData.AI",
    "meta.documentation.title": "文档 - GuGuData.AI | AI 数据集成的 MCP 协议",
    "meta.documentation.description": "GuGuData MCP 协议的综合文档。了解如何将专业数据源与您的 AI 应用程序集成。",
    "meta.documentation.keywords": "GuGuData, MCP 文档, API 参考, 数据集成, 入门指南, 实施指南",
    "notfound.title": "404 - 页面未找到",
    "notfound.description": "抱歉！您访问的页面不存在。",
    "notfound.backHome": "返回首页",

    "documentation.title": "文档",
    "documentation.introduction": "介绍",
    "documentation.getting-started": "快速开始",
    "documentation.features": "功能特性",
    "documentation.api": "API 参考",
    "documentation.examples": "示例",
    "documentation.troubleshooting": "故障排除",

    "documentation.introduction.welcome": "欢迎来到 GuGuData MCP 协议文档。在这里，您将找到全面的指南和文档，帮助您尽快开始使用 GuGuData MCP，以及在遇到问题时获取支持。",
    "documentation.introduction.how_it_works.title": "工作原理",
    "documentation.introduction.how_it_works.description":
      "GuGuData 提供统一协议，连接大型语言模型与专业数据源。当您向我们的 API 发送查询时，已启用的数据连接器会帮助模型使用合适的领域数据处理请求。",
    "documentation.introduction.mcp_plugins.title": "MCP 数据连接器",
    "documentation.introduction.mcp_plugins.description": "MCP 数据连接器通过专业知识和数据处理能力增强 AI 功能。如需启用适合您应用场景的连接器，请联系我们的团队。",
    "documentation.introduction.mcp_plugins.chinese": "中文网站",
    "documentation.introduction.mcp_plugins.international": "英文和日文网站",
    "documentation.introduction.note": "请妥善保管您的 API 密钥，不要与他人共享。如需启用更多数据连接器，请联系我们的团队。",

    "documentation.api.baseurl.title": "基础 URL",
    "documentation.api.example.title": "请求示例",

    "documentation.getting-started.content": "要开始使用，请联系我们的团队获取 API 密钥，并启用符合您应用需求的数据连接器。",
    "documentation.features.content": "探索 GuGuData MCP 协议的各种功能，包括自动加载插件、多语言支持和专业数据源。",
    "documentation.api.content": "我们的 API 使用经过身份验证的 JSON 请求。公开的 Playground 流式接口为 'https://api.gugudata.ai/api/v1/stream'，并需要使用您的 GuGuData AI API 密钥。",
    "documentation.examples.content": "查看这些示例，了解如何使用 MCP 协议与不同数据源集成。",
    "documentation.troubleshooting.content": "查找常见问题的解决方案，并了解如何排除 MCP 实施中的问题。",

    "documentation.api.authentication.title": "身份验证",
    "documentation.api.authentication.description": "所有 API 请求都需要使用您的 GuGuData AI API 密钥进行身份验证。您需要在所有请求的 Authorization 头中包含您的 API 密钥。",
    "documentation.api.authentication.header": "Authorization 头",
    "documentation.api.authentication.note": "将 <GuGuData AI API Key> 替换为您的实际 API 密钥。请妥善保管您的 API 密钥，不要在客户端代码中暴露。",

    "documentation.api.endpoints.title": "端点",
    "documentation.api.endpoints.parameter": "参数",
    "documentation.api.endpoints.type": "类型",
    "documentation.api.endpoints.required": "必需",
    "documentation.api.endpoints.description": "描述",
    "documentation.api.endpoints.yes": "是",
    "documentation.api.endpoints.no": "否",
    "documentation.api.endpoints.example_request": "请求示例",
    "documentation.api.endpoints.example_response": "响应示例",

    "documentation.api.endpoints.chat_completions.title": "创建 Playground 流式请求",
    "documentation.api.endpoints.chat_completions.description": "向 GuGuData AI 发送问题，并从已启用的数据连接器流式返回回答。",
    "documentation.api.endpoints.chat_completions.params.title": "请求参数",
    "documentation.api.endpoints.chat_completions.params.model": "需要回答的用户问题或任务。",
    "documentation.api.endpoints.chat_completions.params.messages": "可选的请求上下文参数。",
    "documentation.api.endpoints.chat_completions.params.stream": "可选的本次请求启用的数据连接器名称。",

  },

  ja: {
    "nav.home": "ホーム",
    "nav.features": "機能",
    "nav.products": "製品",
    "nav.contact": "お問い合わせ",
    "nav.documentation": "ドキュメント",

    "hero.title": "信頼できる専門データを AI アプリケーションへ",
    "hero.subtitle": "GuGuData の専門データを一つの導入経路から利用できます。コネクタの適合性とドキュメントの流れを確認し、チームに必要な API アクセスを申請してください。",
    "hero.cta": "API アクセスを申請",
    "hero.secondaryCta": "ドキュメントを見る",
    "hero.tertiaryCta": "チームに問い合わせる",
    "hero.valuePoint1": "教育、金融、天気、ドキュメント、Web データに対応",
    "hero.valuePoint2": "リクエスト例と Playground の評価フローを提供",
    "hero.valuePoint3": "2015 年からのデータサービス経験と API キー導入支援",

    "trust.title": "評価から本番導入までの明確な流れ",
    "trust.subtitle": "具体的なデータ範囲、確認できるドキュメント、直接の導入支援に基づいて統合を判断できます。",
    "trust.point1.title": "2015 年から続くデータサービス",
    "trust.point1.description": "GuGuData は、AI 製品とデータ活用ワークフローを支えるデータサービスの経験を提供します。",
    "trust.point2.title": "統合前に評価可能",
    "trust.point2.description": "本番アクセスを決める前に、コネクタカテゴリ、リクエスト例、Playground の動作を確認できます。",
    "trust.point3.title": "用途に合わせたアクセス範囲",
    "trust.point3.description": "必要なデータカテゴリ、想定利用量、公開時期、サポート要件をチームと確認できます。",

    "features.title": "MCPプロトコルのパワー",
    "features.subtitle": "MCP がすべてのデータソースへのアクセスを標準化することで、AI アプリケーションをどのように変革できるかをご覧ください。",
    "features.card1.title": "シームレスな統合",
    "features.card1.description": "標準化されたプロトコルを使用して、最小限のコード変更で任意のデータソースを LLM に接続します。",
    "features.card2.title": "モジュラーアーキテクチャ",
    "features.card2.description": "データソースをオンデマンドで追加および削除し、AI が必要とするものに正確にアクセスできるようにします。",
    "features.card3.title": "強化されたコンテキスト",
    "features.card3.description": "AI モデルに必要な専門データを提供し、より関連性の高い正確な応答を提供します。",
    "features.integration.title": "MCP 統合のしくみ",
    "features.integration.subtitle": "MCP を使用するための 3 つの簡単な手順",
    "features.integration.step1.title": "データの接続",
    "features.integration.step1.description": "標準化された MCP プロトコルインターフェースを介して、既存のデータソースを簡単に接続します。",
    "features.integration.step2.title": "統合の設定",
    "features.integration.step2.description": "データマッピングと変換ルールを設定するために、直感的な設定ツールを使用します。",
    "features.integration.step3.title": "AI の強化",
    "features.integration.step3.description": "AI アプリケーションは、すべての接続データソースにシームレスにアクセスできるようになりました。",
    "features.standardized.title": "標準化されたプロトコル",
    "features.standardized.description":
      "MCP は、AI モデルがさまざまなデータソースとツールとの間でシームレスにやり取りするための標準化された方法を提供し、統合を簡単にする共通のフレームワークを作成します。",
    "features.standardized.list.item1": "異なるプラットフォーム間の一貫したデータ形式",
    "features.standardized.list.item2": "開発の複雑さの削減",
    "features.standardized.list.item3": "モデルとデータソース間の一般的な互換性",
    "features.modular.title": "モジュラー統合",
    "features.modular.description": "MCP アーキテクチャは、開発者が異なるデータソースをモジュラーコンポーネントとして簡単に挿入できるようにすることで、AI の能力を必要に応じて強化します。",
    "features.modular.list.item1": "即座にデータソースを統合する",
    "features.modular.list.item2": "異なる LLM プロバイダー間の簡単な切り替え",
    "features.modular.list.item3": "必要に応じて拡張可能なアーキテクチャ",
    "features.cta.title": "AI を強化する準備はできていますか？",
    "features.cta.description": "MCP プロトコルを使用してデータを AI システムに接続する企業のエコシステムに参加します。",
    "features.cta.button": "お問い合わせ",
    "features.external_resources.title": "関連リソース",
    "features.external_resources.subtitle": "MCP統合を強化するための外部リソースとドキュメントを探索",
    "features.external_resources.mcp_spec": "MCP仕様",
    "features.external_resources.mcp_spec_desc": "公式MCPプロトコル仕様と実装ガイドライン",
    "features.external_resources.github_samples": "GitHubサンプル",
    "features.external_resources.github_samples_desc": "MCP統合のサンプル実装とコード例",
    "features.external_resources.community": "開発者コミュニティ",
    "features.external_resources.community_desc": "コミュニティが保守するMCPサーバーと統合例",

    "products.title": "当社の製品",
    "products.subtitle": "AI 機能を強化するための MCP 実装ソリューションをご覧ください。",
    "products.card1.title": "MCPコアAPI",
    "products.card1.description":
      "LLM とデータソース間のシームレスな統合を可能にする当社のフラッグシップ API サービス。当社の API に一度接続するだけで、互換性のあるすべてのデータプロバイダーにアクセスできます。",
    "products.card1.cta": "ドキュメントを見る",
    "products.card2.title": "MCPデータコネクタ",
    "products.card2.description": "人気のデータソースと専門知識ベース用の事前構築されたコネクタ。必要なものを有効にするだけで、AI 機能を強化できます。",
    "products.card2.cta": "コネクタを探索する",
    "products.page.hero.title": "本番 AI ワークフロー向けデータコネクタ",
    "products.page.hero.subtitle": "AI 製品に必要な専門データを評価し、ドキュメントのリクエストフローを確認して、コネクタ範囲と導入計画に合う API アクセスを申請できます。",
    "products.page.hero.primaryCta": "API アクセスを申請",
    "products.page.hero.secondaryCta": "ドキュメントを見る",
    "products.page.hero.proof1": "教育、金融、天気、ドキュメント、Web ユーティリティの専門データ",
    "products.page.hero.proof2": "リクエスト例と Playground の評価フロー",
    "products.page.hero.proof3": "コネクタ範囲と導入要件に合う API キーオンボーディング",
    "products.page.core.title": "MCP コア API",
    "products.page.core.description": "AI アプリケーションを GuGuData のデータ機能と有効化されたコネクタグループにつなぐ統一 API レイヤーです。",
    "products.page.core.point1": "AI アプリケーションのワークフロー向け認証 JSON リクエスト",
    "products.page.core.point2": "データ支援型の回答を評価する Playground ストリームエンドポイント",
    "products.page.core.point3": "開発者の導入を支援するドキュメントと例",
    "products.page.core.cta": "API ドキュメントを見る",
    "products.page.connectors.title": "MCP データコネクタ",
    "products.page.connectors.description": "コネクタグループは、アプリケーションの用途に合わせて有効化できる専門データカテゴリを提供します。",
    "products.page.connectors.point1": "教育、金融、旧暦、天気、Web ユーティリティの例",
    "products.page.connectors.point2": "MCP と AI データ統合ワークフロー向けに設計",
    "products.page.connectors.point3": "追加のコネクタ範囲を相談するための明確な導線",
    "products.page.connectors.cta": "コネクタ例を見る",
    "products.page.support.title": "統合サポート",
    "products.page.support.description": "本番利用に向けて、コネクタ範囲、API キーアクセス、統合アプローチの確認を支援します。",
    "products.page.support.point1": "API キー申請とオンボーディング支援",
    "products.page.support.point2": "具体的なアプリケーションシナリオに合わせたコネクタ有効化",
    "products.page.support.point3": "お問い合わせ経由のビジネス相談と提携相談",
    "products.page.support.cta": "API アクセスを申請",
    "products.page.connectorExamples.title": "コネクタ例のテーマ",
    "products.page.connectorExamples.description": "これらのテーマは、MCP コネクタ、API アクセス、統合サポートを通じて専門データを AI アプリケーションに取り込む一般的な方法を示します。",
    "products.page.theme.education.title": "教育データ",
    "products.page.theme.education.description": "研究、コンテンツ、教育ワークフロー向けの大学、ランキング、学習リソースデータ。",
    "products.page.theme.finance.title": "金融データ",
    "products.page.theme.finance.description": "AI 支援の分析と検索に使える市場情報と金融参照データ。",
    "products.page.theme.webtools.title": "ドキュメントと Web ツール",
    "products.page.theme.webtools.description": "PDF、コンテンツ抽出、SSL、Web ユーティリティなど、実用的な AI アプリケーション向け機能。",
    "products.page.theme.custom.title": "カスタムコネクタ相談",
    "products.page.theme.custom.description": "チームは GuGuData に連絡し、自社のアプリケーションシナリオに合うコネクタ範囲を相談できます。",
    "products.page.journey.title": "チーム向けアクセス手順",
    "products.page.journey.description": "このサイトは、チームが製品を理解し、ドキュメントを確認し、GuGuData に API アクセスを相談するためのものです。",
    "products.page.journey.step1.title": "製品との適合性を確認",
    "products.page.journey.step1.description": "MCP API とコネクタカテゴリが、AI アプリケーションのデータニーズをどのように支援するか確認します。",
    "products.page.journey.step2.title": "API ワークフローを確認",
    "products.page.journey.step2.description": "ドキュメントと Playground の例で、認証付きストリームリクエストの流れを理解します。",
    "products.page.journey.step3.title": "アクセスとコネクタ範囲を申請",
    "products.page.journey.step3.description": "チームに連絡して API キーを申請し、有効化するコネクタグループを確認します。",
    "products.page.journey.cta": "アクセスを申請",
    "products.page.finalCta.title": "専門データを AI ワークフローへ",
    "products.page.finalCta.description": "製品ページで MCP データアクセスモデルを確認し、API アクセスとコネクタ有効化について GuGuData にお問い合わせください。",
    "products.page.finalCta.primary": "チームに問い合わせる",
    "products.page.finalCta.secondary": "ドキュメントを見る",

    "footer.copyright": "全著作権所有。",
    "footer.address": "住所",
    "footer.contact": "お問い合わせ",
    "footer.legal": "利用規約",
    "footer.privacy": "プライバシーポリシー",
    "footer.products": "製品・サービス",
    "footer.chinese_service": "中国語データサービス",
    "footer.global_service": "グローバルデータサービス",
    "footer.resources": "関連リソース",
    "footer.mcp_docs": "MCPプロトコル",
    "footer.anthropic": "Anthropic Claude",
    "footer.openai": "OpenAIプラットフォーム",
    "footer.description": "MCPプロトコルによるAIデータ統合の標準化",

    // Adding chat-related translations for Japanese
    "chat.tryExamples": "以下の例を試してみてください：",
    "chat.example1": "次の二十四節気は何ですか？",
    "chat.example2": "江蘇省のトップ10の211プロジェクト大学の名前を教えてください。",
    "chat.example3": "A株の銘柄600000の現在のリアルタイム基本情報を教えてください。",
    "chat.example4": "最新のQS世界大学ランキングのトップ5大学を教えてください。",
    "chat.placeholder": "MCPデータ統合について質問する...",
    "chat.title": "MCPでGuGuData AIに質問",
    "chat.description": "MCPコネクタのパワーを体験してください。上記のプラグインを切り替えて、専門データソースでAI機能を強化します。",

    "contact.title": "お問い合わせ",
    "contact.subtitle": "API アクセス申請または一般的なデータ相談を選択してください。",
    "contact.apiAccess.title": "GuGuData.AI API アクセスを申請",
    "contact.apiAccess.description": "AI アプリケーションの用途を共有いただければ、コネクタの適合性、アクセス範囲、評価方法を確認します。",
    "contact.apiAccess.cta": "API キー申請を開始",
    "contact.apiAccess.guidance": "用途、必要なデータカテゴリ、想定リクエスト数、公開予定時期をご記載ください。",
    "contact.general.title": "一般的なデータ相談",
    "contact.general.description": "データ範囲、提携、サポート、その他の GuGuData サービスについてお問い合わせください。",
    "contact.general.cta": "チームにメールする",
    "contact.sections.coreAdvantages": "コアアドバンテージ",
    "contact.sections.technicalFeatures": "技術的特徴",
    "contact.sections.solutions": "ソリューション",
    "contact.intro.paragraph1":
      "2015年に設立されたGuGuDataは、データ管理ソリューションから包括的なデータハブへと成長しました。私たちの使命は、革新的なMCPプロトコルを通じて、企業に専門データへのシームレスなアクセスを提供することです。",
    "contact.intro.paragraph2":
      "当社のプラットフォームはシームレスな統合機能を備えており、最小限のコード変更で任意のデータソースをLLMに接続できます。標準化されたプロトコルを通じて、企業クライアントのデータストレージの最適化とパフォーマンスの向上を支援しています。",
    "contact.intro.paragraph3":
      "モジュラーアーキテクチャにより、データソースをオンデマンドで追加・削除でき、AIが必要とするものに正確にアクセスできます。分類されたデータと機能インターフェースは様々な分野をカバーし、アナリスト、企業、研究者、革新者向けの多用途ソリューションを提供します。",
    "contact.intro.paragraph4":
      "効率的なPDF生成、インテリジェントなコンテンツ抽出、SSL証明書情報の解析のための堅牢なツールを提供しています。当社のプラットフォームは複雑なデータセットを簡単に処理できるように設計されており、GuGuDataはスタートアップと確立された企業の両方にとって理想的なデータソリューションとなっています。",
    "contact.intro.paragraph5": "最近、国際化されたサイトとAPIをローンチし、リーチを拡大し、データソリューションをグローバルなオーディエンスにアクセス可能にしました。",
    "contact.intro.paragraph6": "データニーズ、お問い合わせ、フィードバック、パートナーシップの機会について、お気軽にお問い合わせください。",
    "contact.info.title": "お問い合わせ情報",
    "contact.info.company": "GuGuData, LLC",
    "contact.info.address": "1111B S Governors Ave STE 3590\nDover, DE 19904, United States",
    "contact.info.email": "メールアドレス",

    "plugins.financial.title": "金融データ",
    "plugins.financial.description": "リアルタイムの金融市場データと分析ツールにアクセス",
    "plugins.education.title": "教育リソース",
    "plugins.education.description": "教育データベースと学習教材に接続",
    "plugins.lunar.title": "旧暦データ",
    "plugins.lunar.description": "旧暦と祝祭日の情報を取得",
    "plugins.weather.title": "天気",
    "plugins.weather.description": "リアルタイムの天気データと予報にアクセス",
    "plugins.title": "MCP プラグイン",
    "plugins.coming_soon.description": "現在 playground では一部のコネクタを利用できます。追加のデータコネクタを有効にするにはお問い合わせください。",

    // Plugin Categories
    "plugins.text.title": "NLP",
    "plugins.text.description": "自然言語処理とテキスト分析ツール",
    "plugins.image.title": "PDFツール",
    "plugins.image.description": "画像処理とPDF処理ツール",
    "plugins.news.title": "ニュース",
    "plugins.news.description": "ニュースと情報集約サービス",
    "plugins.finance.title": "金融",
    "plugins.finance.description": "基本的な金融データと分析ツール",
    "plugins.business.title": "ビジネス",
    "plugins.business.description": "ビジネスインテリジェンスと分析ツール",
    "plugins.location.title": "位置情報",
    "plugins.location.description": "地理と座標ベースのサービス",
    "plugins.webtools.title": "Webツール",
    "plugins.webtools.description": "様々なWebベースのユーティリティとツール",
    "plugins.ai.title": "AIモデル",
    "plugins.ai.description": "AIモデルと機械学習サービス",
    "plugins.barcode.title": "バーコード",
    "plugins.barcode.description": "バーコード生成とスキャンツール",
    "plugins.sms.title": "SMS",
    "plugins.sms.description": "SMSと音声通信サービス",

    "meta.contact.title": "お問い合わせ - GuGuData",
    "meta.contact.description": "GuGuData は専門的なデータサービスと MCP プロトコル統合を提供します。データサービス、API 統合、カスタマイズソリューションについての詳細はお問い合わせください。",
    "meta.contact.keywords": "GuGuData, MCP, データサービス, API統合, お問い合わせ",
    "meta.home.title": "AI データコネクタと MCP API アクセス | GuGuData.AI",
    "meta.home.description": "AI アプリケーションを GuGuData の教育、金融、天気、ドキュメント、Web データに接続し、コネクタ、ドキュメント、API アクセス方法を確認できます。",
    "meta.home.keywords": "GuGuData.AI, MCP, AIデータ統合, データコネクター, APIプラットフォーム, AIアプリケーション",
    "meta.products.title": "AI ワークフロー向けデータコネクタ | GuGuData.AI",
    "meta.products.description": "GuGuData.AI のデータコネクタ、リクエストフロー、データ範囲、本番 AI アプリケーション向け API キー導入を確認できます。",
    "meta.products.keywords": "MCP データ製品, AI データコネクタ, MCP API, API キー申請, AI データ統合, GuGuData.AI",
    "meta.documentation.title": "ドキュメント - GuGuData.AI | AIデータ統合のためのMCPプロトコル",
    "meta.documentation.description": "GuGuData MCP プロトコルの包括的なドキュメント。専門データソースを AI アプリケーションと統合する方法をご覧ください。",
    "meta.documentation.keywords": "GuGuData, MCPドキュメント, APIリファレンス, データ統合, 入門ガイド, 実装ガイド",
    "notfound.title": "404 - ページが見つかりません",
    "notfound.description": "申し訳ありません！お探しのページは存在しません。",
    "notfound.backHome": "ホームに戻る",

    "documentation.title": "ドキュメント",
    "documentation.introduction": "紹介",
    "documentation.getting-started": "はじめに",
    "documentation.features": "機能特性",
    "documentation.api": "API 参考",
    "documentation.examples": "例",
    "documentation.troubleshooting": "トラブルシューティング",

    "documentation.introduction.welcome":
      "GuGuData MCP プロトコルのドキュメントへようこそ。ここでは、GuGuData MCP の使用をできるだけ早く開始するための包括的なガイドとドキュメント、および問題が発生した場合のサポートを見つけることができます。",
    "documentation.introduction.how_it_works.title": "仕組み",
    "documentation.introduction.how_it_works.description":
      "GuGuData は、大規模言語モデルを専門データソースに接続するための統一プロトコルを提供します。API にクエリを送信すると、有効化されたデータコネクタが適切な専門データを使った回答を支援します。",
    "documentation.introduction.mcp_plugins.title": "MCP データコネクタ",
    "documentation.introduction.mcp_plugins.description":
      "MCP データコネクタは、専門知識とデータ処理機能を提供することで AI 機能を強化します。用途に合うコネクタを有効にするにはお問い合わせください。",
    "documentation.introduction.mcp_plugins.chinese": "中国語ウェブサイト",
    "documentation.introduction.mcp_plugins.international": "英語・日本語ウェブサイト",
    "documentation.introduction.note": "API キーを安全に保管し、他人と共有しないでください。追加のデータコネクタが必要な場合はお問い合わせください。",

    "documentation.api.baseurl.title": "ベース URL",
    "documentation.api.example.title": "リクエスト例",

    "documentation.getting-started.content": "開始するには、API キーと用途に合うデータコネクタについてお問い合わせください。",
    "documentation.features.content": "自動プラグインローディング、多言語サポート、専門データソースなど、GuGuData MCP プロトコルのさまざまな機能を探索してください。",
    "documentation.api.content":
      "当社の API は認証付き JSON リクエストを使用します。公開 playground stream endpoint は 'https://api.gugudata.ai/api/v1/stream' で、GuGuData AI API キーが必要です。",
    "documentation.examples.content": "これらの例を確認して、MCP プロトコルを使用してさまざまなデータソースと統合する方法を学びましょう。",
    "documentation.troubleshooting.content": "一般的な問題の解決策を見つけ、MCP 実装における問題のトラブルシューティング方法を学びましょう。",

    "documentation.api.authentication.title": "認証",
    "documentation.api.authentication.description":
      "すべての API リクエストには、GuGuData AI API キーを使用した認証が必要です。すべてのリクエストの Authorization ヘッダーに API キーを含める必要があります。",
    "documentation.api.authentication.header": "認証ヘッダー",
    "documentation.api.authentication.note": "<GuGuData AI API Key> を実際の API キーに置き換えてください。API キーを安全に保管し、クライアント側のコードで公開しないでください。",

    "documentation.api.endpoints.title": "エンドポイント",
    "documentation.api.endpoints.parameter": "パラメータ",
    "documentation.api.endpoints.type": "タイプ",
    "documentation.api.endpoints.required": "必須",
    "documentation.api.endpoints.description": "説明",
    "documentation.api.endpoints.yes": "はい",
    "documentation.api.endpoints.no": "いいえ",
    "documentation.api.endpoints.example_request": "リクエスト例",
    "documentation.api.endpoints.example_response": "レスポンス例",

    "documentation.api.endpoints.chat_completions.title": "Playground ストリームリクエストを作成",
    "documentation.api.endpoints.chat_completions.description": "GuGuData AI に質問を送信し、有効化されたデータコネクタから回答をストリームします。",
    "documentation.api.endpoints.chat_completions.params.title": "リクエストパラメータ",
    "documentation.api.endpoints.chat_completions.params.model": "回答したいユーザーの質問またはタスク。",
    "documentation.api.endpoints.chat_completions.params.messages": "任意のリクエストコンテキスト。",
    "documentation.api.endpoints.chat_completions.params.stream": "任意で有効にするデータコネクタ名。",

  },
};

export default translations;
